module.exports = __webpack_public_path__ + "img/partner_img26.b0944226.png";